<div class="flxClmn" style="height: calc(100vh - 50px);">
    <div class="page-title-container flxRow-between">
        <div class="flxClmn-center f-1-0">
            <div class="page-title-inner-container flxRow">
                <span class="page-title">Email Activity</span>

                <!--Information modal-->
                <more-info-c>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Actions</span>
                        <br/>
                        <span style="vertical-align: middle;"><b>Threat Analysis</b> - view the threat analysis for the email components (links/files/headers) and take actions on the email</span>
                        <span style="vertical-align: middle;"><b>Show Content and Actions</b> - view the content of the quarantined email and take actions on it</span>
                        <span style="vertical-align: middle;"><b>Release to mailbox</b> - release the email back to the recipient's inbox. Only do this if you know the email is safe</span>
                        <span style="vertical-align: middle;"><b>Remove from mailbox</b> - remove the email from the recipient's mailbox. Note: removed emails can still be recovered using the "Release" action</span>
                        <span style="vertical-align: middle;"><b>Set category</b> - manually change the category of the quarantined email</span>
                        <span style="vertical-align: middle;"><b>Download as EML</b> - download the quarantined email (including attachments) as an EML file</span>
                        <span style="vertical-align: middle;"><b>Preserve record</b> - select the email to be preserved and not be deleted by the default retention policy</span>
                        <span style="vertical-align: middle;"><b>Delete record</b> - delete the record for the quarantined email on this page. The actual email will not be affected.</span>
                    </div>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Status</span>
                        <br/>
                        <span style="vertical-align: middle;"><b style="color: darkorange;">Quarantined</b> - a potential threat has been found in the email. An admin can either remove or release a quarantined email</span>
                        <span style="vertical-align: middle;"><b style="color: green;">Released</b> - an admin has found the email to be safe and released it back to the recipient's inbox</span>
                        <span style="vertical-align: middle;"><b style="color: dimgray;">Pending release</b> - this email is being released to the recipient's mailbox</span>
                        <span style="vertical-align: middle;"><b style="color: green;">Requested release</b> -  the recipient has requested to release this email from quarantine</span>
                        <span style="vertical-align: middle;"><b style="color: red;">Removed</b> - an admin has found the email to be malicious and removed it completely</span>
                    </div>
                </more-info-c>
            </div>

			<div class="page-subtitle-container flxClmn vSpace05" style="align-items: flex-start;">
                <span class="page-subtitle">Email processed by Inbound Shield — quarantined, released and delivered</span>
			</div>
        </div>

		<div class="flxClmn vSpace05" style="align-items: flex-end;">
			<btn-c style="align-self: flex-end;"
				   *ngIf="isRecipientChangeNotifyTimeAllowed && mailboxInfo"
				   endIcon="far fa-bell" variant="outlined"
				   (action)="openNotifyOptionsPopup();">
				Quarantine Notifications
			</btn-c>
		</div>

		<div class="control-and-info-icons flxRow"></div>
    </div>
    <div class="page-inner-content-holder flxClmn no-scroll" id="sharedplanactiveMobile"
         [ngStyle]="{'min-height' : groupEmails.length > 2 ? '545px' : 'unset'}">

		<!--For security reviewers:-->
		<div class="security-reviewer-weekly-stats-strip bs-enabled hSpace05 w100"
			 style="margin: 0 0 13px;border: solid 2px #e0e7ff;border-radius: 4px;padding: 11px;background: var(--bs-light);"
			 *ngIf="reviewerInfo?.is_security_reviewer">
			<span class="security-reviewer-strip-segment">
				<b class="security-reviewer-strip-label">Weekly Releases:</b>
				<span class="security-reviewer-strip-value">
					<span class="fw-500 text-muted" *ngIf="quarantinedViewNeedsPlanSelection">A plan must be selected first</span>
					<ng-container *ngIf="!quarantinedViewNeedsPlanSelection">
						<span class="fw-500" *ngIf="!quarantinedPlanInfoLoaded || securityReviewerWeeklyReleasesInProcess || getEmailsInProcess">Loading...</span>
						<span class="fw-500 text-muted" *ngIf="quarantinedPlanInfoLoaded && !(securityReviewerWeeklyReleasesInProcess || getEmailsInProcess) && !securityReviewerWeeklyStatsFromFetch">Get Emails first</span>
						<span class="fw-500"
							  *ngIf="quarantinedPlanInfoLoaded && !(securityReviewerWeeklyReleasesInProcess || getEmailsInProcess) && securityReviewerWeeklyStatsFromFetch"
							  [ngStyle]="{ color: securityReviewerWeeklyReleasesTotal < 30 ? 'darkgreen' : (securityReviewerWeeklyReleasesTotal > 50 ? 'darkred' : 'darkorange') }">
							{{securityReviewerWeeklyReleasesTotal}}
						</span>
					</ng-container>
				</span>
			</span>
			<span class="text-muted flex-shrink-0 px-1 security-reviewer-strip-sep" style="opacity: 0.55; user-select: none;" aria-hidden="true">|</span>
			<span class="security-reviewer-strip-segment">
				<b class="security-reviewer-strip-label">Top quarantine tags:</b>
				<span class="security-reviewer-strip-value">
					<span class="fw-500 text-muted" *ngIf="quarantinedViewNeedsPlanSelection">A plan must be selected first</span>
					<ng-container *ngIf="!quarantinedViewNeedsPlanSelection">
						<span class="fw-500" *ngIf="!quarantinedPlanInfoLoaded || securityReviewerWeeklyReleasesInProcess || getEmailsInProcess">Loading...</span>
						<span class="fw-500 text-muted" *ngIf="quarantinedPlanInfoLoaded && !(securityReviewerWeeklyReleasesInProcess || getEmailsInProcess) && !securityReviewerWeeklyStatsFromFetch">Get Emails first</span>
						<span class="security-reviewer-strip-tag-pills"
							  *ngIf="quarantinedPlanInfoLoaded && !(securityReviewerWeeklyReleasesInProcess || getEmailsInProcess) && securityReviewerWeeklyStatsFromFetch && securityReviewerWeeklyTopTags?.length">
							<span class="threat-tag hvr-opacity flex-shrink-0"
								  *ngFor="let tag of securityReviewerWeeklyTopTags; trackBy: trackSecurityReviewerWeeklyTag"
								  [ngClass]="tag.colorObj?.color"
								  [class.fw-bold]="activeTagAsFilter === tag.sub_status"
								  [ngStyle]="{'color': tag.colorObj?.color, 'border-radius': '4px'}"
								  (click)="activeTagAsFilter = tag.sub_status; quarantinedTable.searchItem();">
								<span class="threat-tag-BG"></span>
								<i class="far threat-tag-icon" [ngClass]="tag.colorObj?.icon"></i>
								<span class="threat-tag-text">{{tag.sub_status}} ({{tag.count}})</span>
							</span>
						</span>
						<span class="fw-500 text-muted" *ngIf="quarantinedPlanInfoLoaded && !(securityReviewerWeeklyReleasesInProcess || getEmailsInProcess) && securityReviewerWeeklyStatsFromFetch && !securityReviewerWeeklyTopTags?.length">—</span>
					</ng-container>
				</span>
			</span>
		</div>
		<!---->

		<div class="w100 flxRow-between" style="z-index: 10;">
            <ng-template #queryEl>
                <!--query-->
                <div class="flxRow" (clickOutside)="showQueryModal = false;" style="align-items: center; position: relative; width: fit-content;">
                    <div class="flxRow" style="flex: 1 0; border: solid 1px var(--ui-border-strong); border-radius: var(--ui-radius-sm); overflow: visible; position: relative; min-width: 485px; height: 32px;"
                         [ngStyle]="{'border-color' : isQueryError ? 'red' : 'var(--ui-border-strong)'}">
                        <div class="flxRow hSpace05" style="align-items: center; padding: 10px; border-right: solid 1px var(--ui-border-strong); cursor: pointer; border-radius: var(--ui-radius-sm) 0 0 var(--ui-radius-sm);"
                             (click)="showQueryModal = !showQueryModal"
                             [ngStyle]="{'background' : showQueryModal ? '#f7f7f7' : 'white'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 22px; height: 22px; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zM272.1 657.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM853.8 847.5L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zM467.9 860.2H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5 0.1 23.9-19.5 43.5-43.5 43.5z"/><path d="M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5z m0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"/></svg>
                            <i class="far fa-chevron-down" style="font-size: smaller;"></i>
                        </div>

                        <div class="flxRow hSpace1  hvr-shadow" style="flex: 1 0; align-items: center; padding: 0 10px; cursor: pointer;"
                             (click)="showQueryModal = !showQueryModal">
                            <a class="diamond-indent animated fadeIn" style="font-weight: bold; height: auto; position: relative; padding-left: 12px; text-transform: capitalize;"
                               *ngFor="let query of quarantinedQueryDisplay; trackBy: gs.trackByIndex"
                               tooltip="{{query.tooltip}}">
                                {{query.title}}
                            </a>
                        </div>

                        <!--query modal-->
                        <div style="position: absolute; bottom: -3px; transform: translateY(100%); line-height: 15px; left: 0; background: white; border: solid 1px var(--ui-border); border-radius: var(--ui-radius-md); box-shadow: var(--ui-shadow-lg); min-width: 537px;"
                             *ngIf="showQueryModal">
                            <div class="flxClmn vSpace2" style="padding: 20px;">
								<div class="flxRow-between" style="align-items: center; height: 30px; z-index: 150; margin: 0;">
									<span style="font-weight: bold; font-size: 14px">Emails Search Query</span>
									<table-query-templates-dropdown style="width: 220px;"
																	[queryModalModel]="quarantinedQuery"
																	(click)="$event.stopPropagation();"
																	(onTemplateSelected)="selectQueryTemplate($event.query)">
									</table-query-templates-dropdown>
								</div>
								<hr class="w100" style="opacity: 0.5;"/>
								<div class="flxRow hSpace1 bs-enabled" style="align-items: center; margin-bottom: 10px;" *ngIf="isExchangeConnected">
									<span style="font-weight: bold; margin-top: 5px; flex-basis: 113px;">Source:</span>
									<div class="checkbox-button radio-style gap-1" style="padding: 5px 10px;"
										 *ngFor="let source of emailsSources | keyvalue: gs.returnZero; trackBy: gs.trackByIndex"
										 [ngClass]="{'selected' : quarantinedQuery.source === source.value}"
										 (click)="selectMainSource(source.value);">
										<label class="radio-container">
											{{source.value}}
											<input type="radio" readonly
												   [checked]="quarantinedQuery.source === source.value">
											<span class="checkmark"></span>
										</label>
										<i style="font-weight: 400;" class="far fa-question-circle"
										   tooltip="Display quarantined emails from your {{source.value === emailsSources.trustifi ? 'Trustifi database' : 'Exchange server'}} according to the selected query parameters." >
										</i>
									</div>
								</div>
								<div class="flex-row align-items-center" *ngIf="displayViewAllPlansBtn" [ngClass]="{'disabled-overlay': quarantinedQuery.source !== emailsSources.trustifi}">
									<span style="font-weight: bold; margin-top: 5px; flex-basis: 113px;">View plans:</span>
									<div class="f-1-0" style="padding-left: 10px;">
										<app-dropdown-c id="viewPlanSelection" class="animated fadeIn"  style="position: relative; z-index: 52; display: block; max-width: 293px;" (click)="clearSearchPlan();"
											[text]="_.every(viewPlanList, 'selected') ? 'All plans' : viewMyPlanOnly ? 'My plan' : _.map(_.filter(viewPlanList, 'selected'), 'display_email').join(', ') || 'Select a plan'">
											<ul style="max-height: 195px; overflow: auto; min-height: 160px;">
												<li (click)="selectViewPlan('onlyMyPlan'); $event.stopPropagation()">
													<checkbox (click)="$event.preventDefault();" [(model)]="viewMyPlanOnly">My plan</checkbox>
												</li>
												<li (click)="selectViewPlan('all'); $event.stopPropagation()">
													<checkbox (click)="$event.preventDefault();" [model]="_.every(viewPlanList, 'selected')">All plans</checkbox>
												</li>
												<li class="static-item pt-2 pb-3" style="min-height: 0;" (click)="$event.stopPropagation()">
													<div class="search-box flxRow" style="position: relative;">
														<input type="search" class="w-100"
															   [(ngModel)]="searchPlanTxt"
															   maxlength="{{dic.CONSTANTS.maxCharsInSearch}}"
															   (keyup)="searchPlan(searchPlanTxt);"
															   placeholder="Search plan">
														<a class="closeRed animated fadeIn"
														   id="clearSearchPlan"
														   (click)="clearSearchPlan();"
														   *ngIf="searchPlanTxt"
														   style="font-size: 16px; color: #cccccc; position: absolute; right: 15px; top: calc(50% + 1px); transform: translateY(-50%);">
															<i class="zmdi zmdi-close"></i>
														</a>
													</div>
												</li>
												<li *ngFor="let plan of viewPlanList"
													(click)="selectViewPlan(plan); $event.stopPropagation();" [hidden]="plan.hide"
													[id]="plan.display_email">
													<checkbox class="ellipsis" [model]="plan.selected" (click)="$event.preventDefault();">
														{{plan.display_email || ''}}
													</checkbox>
												</li>
											</ul>
										</app-dropdown-c>
									</div>
								</div>

                                <div class="flxRow hSpace2">
                                    <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                        <input type="radio" name="normalQuery" [value]="queryTypes.normal"
                                               [(ngModel)]="queryType"
                                               [checked]="queryType === queryTypes.normal"
                                               (ngModelChange)="queryValidationErrors = [];">
                                        <span class="checkmark"></span>
                                    </label>
                                    <div class="flxClmn vSpace2" style="padding-left: 15px; flex: 1 0;"
                                         [ngStyle]="queryType === queryTypes.messageIdOnly ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
                                         (click)="queryType = queryTypes.normal">
                                        <div class="flxRow hSpace2">
                                            <span style="font-weight: bold; flex-basis: 89px; margin-top: 5px;">Date:</span>
                                            <div class="flxClmn" style="margin-left: 0; flex: 1 0;">
                                                <app-dropdown-c class="capitalize-box" style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 293px;"
                                                              [ngStyle]="{'margin-bottom' : resultsPeriod.value === dic.CONSTANTS.trendsPeriod.range.value ? '10px' : '0'}"
                                                              text="{{resultsPeriod?.display}}">
                                                    <li *ngFor="let item of searchPeriod| keyvalue: gs.returnZero;"
                                                        (click)="changePeriod(item.value)">
                                                        {{item.value.display}}
                                                    </li>
                                                </app-dropdown-c>
                                                <div *ngIf="resultsPeriod.value === dic.CONSTANTS.trendsPeriod.range.value"
                                                     class="flxRow bs-enabled" style="position: relative; align-items: center; margin-top: -4px; margin-left: 6px;">
													<div class="flex-row f-1-0 gap-2" style="max-width: 340px;">
														<div class="flxRow hSpace05 f-1-0" style="align-items: center;">
															<span>Date Range:</span>
															<date-picker-c class="f-1-0" style="max-width: 220px;"
																		   [(dateModel)]="range"
																		   [isRange]="true"
																		   [dateFormat]="'mm/dd/yyyy'">
															</date-picker-c>
														</div>
													</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flxRow hSpace3" style="align-items: center; z-index: 4; position: relative;">
                                            <span style="font-weight: bold; flex-basis: 85px;">Category:</span>
												<app-dropdown-c style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 293px; margin: 0;"
															  [error]="queryValidationErrors?.includes('category')"
															  text="{{quarantinedQuery.category && _.keys(_.pickBy(quarantinedQuery.category)).join(', ') || 'Select'}}">
													<li *ngFor="let category of quarantinedQuery.category | keyvalue : gs.returnZero"
														(click)="quarantinedQuery.category[category.key] = !quarantinedQuery.category[category.key]; $event.stopPropagation();"
														id="{{'queryCategories-' + category.key}}">
														<checkbox (click)="$event.preventDefault();" [model]="quarantinedQuery.category[category.key]">
															{{category.key}}
														</checkbox>
													</li>
												</app-dropdown-c>
												<span style="position: absolute; bottom: -1px; right: calc(20% + 7px); transform: translateY(15px); font-size: 12px; color: red;"
													  *ngIf="queryValidationErrors?.includes('category')">
												select at least 1
											</span>
                                        </div>

										<div class="flxRow hSpace3" style="align-items: center; z-index: 3; position: relative;"
											 *ngIf="quarantinedQuery.source === emailsSources.trustifi">
											<span style="font-weight: bold; flex-basis: 85px;">Sub Category:</span>
											<app-dropdown-c style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 293px; margin: 0;"
														  text="{{quarantinedQuery.sub_category && _.keys(_.pickBy(quarantinedQuery.sub_category)).join(', ') || '(Optional)'}}">
												<ul style="overflow: auto; max-height: 180px;">
													<li *ngFor="let status of quarantinedQuery.sub_category | keyvalue: gs.returnZero"
														(click)="quarantinedQuery.sub_category[status.key] = !quarantinedQuery.sub_category[status.key]; $event.stopPropagation();"
														id="{{'queryCategories-' + status.key}}">
														<checkbox (click)="$event.preventDefault();" [model]="quarantinedQuery.sub_category[status.key]">
															{{status.key}}
														</checkbox>
													</li>
												</ul>
											</app-dropdown-c>
										</div>
										<div class="flxRow hSpace3" style="align-items: center; z-index: 2; position: relative;">
											<span style="font-weight: bold; flex-basis: 85px;">Status:</span>
											<app-dropdown-c style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 293px; margin: 0;"
														  text="{{quarantinedQuery.status && _.keys(_.pickBy(quarantinedQuery.status)).join(', ') || '(Optional)'}}">
												<li *ngFor="let status of quarantinedQuery.status | keyvalue : gs.returnZero"
													(click)="quarantinedQuery.status[status.key] = !quarantinedQuery.status[status.key]; $event.stopPropagation();"
													id="{{'queryStatus-' + status.key}}">
													<checkbox (click)="$event.preventDefault();" [model]="quarantinedQuery.status[status.key]">
														{{status.key}}
													</checkbox>
												</li>
											</app-dropdown-c>
										</div>
                                        <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                            <span style="font-weight: bold; flex-basis: 85px;">Sender:</span>
                                            <input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="Sender's email/domain/ip"
                                                   [(ngModel)]="quarantinedQuery.sender">
                                        </div>
                                        <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                            <span style="font-weight: bold; flex-basis: 85px;">Mailbox:</span>
                                            <input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="Recipient's email address"
                                                   [(ngModel)]="quarantinedQuery.mailbox_email">
                                        </div>
                                        <div class="flxRow hSpace3" style="align-items: center; position: relative;">
                                            <span style="font-weight: bold; flex-basis: 85px;">Subject:</span>
                                            <input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="Email's subject (exact or partial)"
                                                   [(ngModel)]="quarantinedQuery.subject">
                                        </div>
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 85px;">Link:</span>
											<input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="Link in email body (exact or partial)"
												   [(ngModel)]="quarantinedQuery.link">
										</div>
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 85px;">File:</span>
											<input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="File name/hash"
												   [(ngModel)]="quarantinedQuery.file">
										</div>
                                    </div>
                                </div>

                                <div class="flxRow hSpace2" style="align-items: flex-start;">
                                    <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                        <input type="radio" name="byIdQuery" [value]="queryTypes.messageIdOnly"
                                               [(ngModel)]="queryType"
                                               [checked]="queryType === queryTypes.messageIdOnly"
                                               (ngModelChange)="queryValidationErrors = [];">
                                        <span class="checkmark"></span>
                                    </label>
                                    <div class="flxRow hSpace3" style="align-items: center; padding-left: 15px; flex: 1 0; position: relative;"
										 *ngIf="quarantinedQuery"
										 [ngStyle]="queryType === queryTypes.normal ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
                                         (click)="queryType = queryTypes.messageIdOnly">
                                        <span style="font-weight: bold; flex-basis: 85px;">Message ID:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
											   (keyup.enter)="applyQuery();"
											   [(ngModel)]="quarantinedQuery.message_id"
											   placeholder="Exact message ID"
                                               [ngClass]="{'validation-error' : queryValidationErrors?.includes('message_id')}">
                                        <span style="position: absolute; bottom: -1px; right: calc(20% + 7px); transform: translateY(15px); font-size: 12px; color: red;"
                                              *ngIf="queryValidationErrors?.includes('message_id')">
                                            required field
                                        </span>
                                    </div>
                                </div>

								<hr class="w100" style="opacity: 0.5;"/>

								<div class="flxRow-between w100 hSpace2" style="align-items: center;">
									<table-query-templates-controls class="bs-enabled"
																	(click)="$event.stopPropagation();"
																	[getCurrentQueryModelAsTemplateFn]="getCurrentQueryModelAsTemplate">
									</table-query-templates-controls>
									<div class="flxRow" style="gap: 8px;">
										<btn-c variant="text" style="height: 32px;"
											   btnTooltip="Reset all query fields" (action)="resetQuery(); tableQueryTemplatesService.clear();">
											Reset
										</btn-c>
										<btn-c style="height: 32px;"
											   id="getQueryEmailsBtnInner"
											   [loading]="getEmailsInProcess"
											   (action)="applyQuery()">
											Get Emails
										</btn-c>
									</div>
								</div>

                            </div>
                        </div>
                    </div>

					<div class="btn-with-dropdown" style="height: 32px; margin-left: -2px;" [style.width.px]="reviewerInfo?.is_security_reviewer ? 165 : 150">
						<btn-c (action)="applyQuery();" class="connected-to-left"
							   [loading]="{flag: getEmailsInProcess}">
							Get Emails
						</btn-c>
						<app-dropdown-c [isLf]="true">
							<!-- CC: new quick actions are released to security reviewers only for now -->
							<ul *ngIf="reviewerInfo?.is_security_reviewer; else legacyQuickActions">
								<li class="flex-row align-items-center" (click)="getImportantEmailsQuickAction()"
									[ngClass]="{'disabled': getEmailsInProcess}">
									Important Emails
									<!-- CC: taken from content.component.html -> isNewFeature "New" tag -->
									<span class="new-page-btn align-self-center ms-2" style="font-size: 8px; padding: 2px 6px;">New</span>
								</li>
								<li (click)="getRequestReleaseEmailsQuickAction()"
									[ngClass]="{'disabled': getEmailsInProcess}">
									Release Requests
								</li>
								<li (click)="getQuarantinedEmailsQuickAction()"
									[ngClass]="{'disabled': getEmailsInProcess}">
									Quarantined Emails
								</li>
								<li (click)="getReportedEmailsQuickAction()"
									[ngClass]="{'disabled': getEmailsInProcess}">
									Reported Emails
								</li>
							</ul>
							<ng-template #legacyQuickActions>
								<ul>
									<li (click)="getQuarantinedEmailsQuickAction()"
										[ngClass]="{'disabled': getEmailsInProcess}">
										Get Quarantined Emails
									</li>
									<li (click)="getReportedEmailsQuickAction()"
										[ngClass]="{'disabled': getEmailsInProcess}">
										Get Reported Emails
									</li>
									<li (click)="getRequestReleaseEmailsQuickAction()"
										[ngClass]="{'disabled': getEmailsInProcess}">
										Get Requested Release Emails
									</li>
								</ul>
							</ng-template>
						</app-dropdown-c>
					</div>

                    <!--abort loading label-->
                    <span class="flxClmn-center animated fadeIn" style="cursor: pointer; padding: 0 6px; font-weight: 300; color: #85000d; font-size: 0.75rem; margin-left: 10px;"
						  *ngIf="showAbortLoadingEmailsLabel"
                          (click)="abortLoadingEmails()">
                        <b>Abort</b>
                    </span>
                </div>
            </ng-template>
		</div>

		<!--emails table-->
		<trustifi-table-c
			class="trustifi-table quarantined-email-table bs-enabled" style="flex: 1 0; z-index: 5;"
			#quarantinedTable
			[list]="groupEmails"
			[headers]="[
				{text: 'Received', sortKey: 'created', width: '98px'},
				{text: '', width: '22px'},
				{html: 'senderHeader', sortKey: 'sender', style: {'padding-left' : '3px'}},
				{text: '', width: '37px'},
				{text: 'Subject', sortKey: 'subject', style: {'padding-left' : '3px'}},
				{text: 'Mailbox', sortKey: 'mailbox_email'},
				{text: 'Status', sortKey: 'status'},
				{text: 'Category', sortKey: 'category_priority', width: '108px'},
				{html: 'tagsHeader', width: '196px'},
				{text: '', width: '24px'}
			]"
			[cellsPrototype]="[
				{html: 'createdCell'},
				{html: 'keepForeverCell'},
				{html: 'senderCell', style: {'padding-left' : '3px'}},
				{html: 'attachmentsOrLinksIconCell'},
				{html: 'subjectCell', style: {'padding-left' : '3px'}},
				{html: 'mailboxCell'},
				{html: 'statusCell'},
				{html: 'categoryCell'},
				{html: 'tagsCell', overflowOutside: true},
				{html: 'handledCell'},
			]"
			(onAnyItemSelected)="!$event.isItemSelectCheckboxClicked && openThreatAnalysisFromRow($event.item)"
			[bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectMultipleEmailsAction,
				initBulkActionsFunction: showMultipleQuarantinedActions,
				showInRed: {enable: true, terms: dic.CONSTANTS.quarantinedActions.delete.display}
			}"
			[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectAction,
				initActionsFunction: showQuarantinedActions,
				showInRed: {enable: true, terms: dic.CONSTANTS.quarantinedActions.delete.display}
			}"
			(searchFunction)="searchEmail($event.searchTerm, $event.activeFilters)"
			[filterData]="filterData"
			[subRowOptions]="{
				recursionKey: 'emails',
				allowActions: true
			}"
			[options]="{
		  		exportToCsvFunction: exportQuarantinedCsv,
				menus: [autoRefreshMenuData],
				loadingTableFlag: getEmailsInProcess && !groupEmails?.length,
				itemsNameSingular: 'email',
				countAlsoSubItems: true,
				itemUniqueIdentifier: '_id',
				defaultSortKey: '-created',
				enableNegativeSearch: gs.reviewerInfo?.is_security_reviewer,
				emptyStateMessage: 'Create a search query and click <b>Get Emails</b>. If no emails appear, refine your filters and try again'
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
		  	<span *ngIf="cellId === 'tagsHeader'">
					<div class="flxRow w100" style=" align-items: center; width: 100%;">
						<span style="flex-shrink: 0;">Metrics</span>
						<a class="flxRow" style="color: royalblue; font-weight: 400; padding: 5px 10px; flex: 1 0; align-items: center;"
						   *ngIf="activeTagAsFilter"
						   (click)="this.activeTagAsFilter = ''; quarantinedTable.searchItem();">
							<span class="hvr-underline" style="white-space: normal; text-align: center; font-size: calc(0.7rem + 0.05vw);">
							   {{activeTagAsFilter}}
							</span>
							<i class="far fa-times" style="white-space: normal; padding: 5px;"></i>
						</a>
					</div>
				</span>
				<span *ngIf="cellId === 'senderHeader'">
					<div class="flex-row align-items-center gap-1">
							<span>Sender</span>
							<i class="far fa-object-group"
							   [ngClass]="{'color-primary': groupBySender}"
							   style="cursor: pointer;"
							   tooltip="Group by sender"
							   (click)="toggleGroupBySender(); $event.stopPropagation();">
							</i>
					</div>
				</span>
				<span *ngIf="cellId === 'createdCell'">
					<span class="text-muted" style="white-space: normal; text-overflow: unset; display: block; max-width: min-content; font-size: 11.5px; line-height: 1.3;"
						  *ngIf="item.parent">
							{{item.created | date:'MM/dd/yyyy HH:mm'}}
					</span>
				</span>
				<span *ngIf="cellId === 'keepForeverCell'">
					<i class="far fa-lock text-muted" *ngIf="item.keep_forever"
					   tooltip="This email will not be deleted by the retention policy">
					</i>
				</span>
				<span *ngIf="cellId === 'handledCell'">
					<i [ngStyle]="!item.reviewed_completed && {'visibility': 'hidden'}"
					   class="far fa-check" style="color: green; padding-right: 4px;"
					   tooltip="Email was handled by a reviewer"></i>
					<i *ngIf="reviewerInfo.mark_follow"
					   class="far fa-thumbtack" style="padding-right: 4px;"
					   tooltip="Marked follow"></i>
				</span>
				<span *ngIf="cellId === 'senderCell'">
					<div class="flxRow ellipsis" style="position: relative;" [tooltip]="!item.parent && item.sender ? item.sender : null">
						<ng-container *ngIf="item.parent">
							<ng-container *ngTemplateOutlet="cToolTipTemplate; context: {$implicit: item}"></ng-container>
						</ng-container>

						<i class="fa" style="margin-right: 3px;" *ngIf="item.auth_sender?.status"
						   [ngClass]="{'fa-exclamation-circle text-muted' : item.auth_sender.status === 'request',
										'fa-check-circle text-success' : item.auth_sender.status === 'approve',
										'fa-exclamation-circle text-danger' : item.auth_sender.status !== 'request' && item.auth_sender.status !== 'approve'}"
						   tooltip="Sender has {{item.auth_sender.status === 'request' ? 'not yet responded to' : item.auth_sender.status === 'approve' ? 'approved': 'denied'}} the authentication request"
						   placement="bottom">
						</i>
						<span>{{item.sender || 'None'}}</span>
					</div>
				</span>
				<div *ngIf="cellId === 'attachmentsOrLinksIconCell'"
					 class="flex-row gap-1 align-items-center justify-content-end" style="padding-right: 2px;">
					<i class="far fa-link text-muted" *ngIf="item.links"
					   tooltip="{{item.links > 1 ? item.links + ' links' : '1 link'}}"></i>
					<i class="zmdi zmdi-attachment-alt text-muted" *ngIf="item?.attachments"
					   style="font-size: 14px;"
					   tooltip="{{item.attachments > 1 ? item.attachments + ' attachments' : '1 attachment'}}"></i>
				</div>
				<span *ngIf="cellId === 'subjectCell'">
					<span [ngClass]="{'text-muted' : !item.subject}"
						  [tooltip]="item.subject ? (item.subject | sanitizeText) : null">
						{{item.subject || 'None'}}
					</span>
				</span>
				<span *ngIf="cellId === 'mailboxCell'">
					<ng-container *ngIf="item.parent && item.mailbox_email">
						<div class="flex-row gap-1" style="align-items: center; cursor: pointer;"
							 *ngIf="item.mailbox_email.length > 1 || (groupBySender && item.visibleEmailsCount > 1)"
							 [tooltip]="item.mailbox_email.join(', ')"
							 (click)="toggleExpandItem(item, $event); quarantinedTable.searchItem();">
								<a class="blue-link text-decoration-underline">
										{{groupBySender ? item.visibleEmailsCount + ' emails' : item.mailbox_email.length + ' mailboxes'}}
								</a>
								<i class="far fa-chevron-left" style="color: royalblue; transition: transform 0.15s ease-out; padding: 5px;"
								   [ngStyle]="{'transform' : item.isExpanded ? 'rotate(-90deg)' : 'rotate(0deg)'}"></i>
						</div>
						<div class="flex-column" *ngIf="item.mailbox_email.length === 1 && !(groupBySender && item.visibleEmailsCount > 1)">
							<span class="ellipsis" [tooltip]="item.mailbox_email[0]">{{item.mailbox_email[0]}}</span>
							<ng-container *ngTemplateOutlet="mailboxJobTitleTemplate; context: {$implicit: item}"></ng-container>
						</div>
					</ng-container>

					<ng-container *ngIf="item.depthLevel">
						<div class="flex-column" style="margin-left: 15px;">
							<span class="ellipsis"
								  [ngClass]="{'text-muted' : !item.mailbox_email}"
								  [tooltip]="item.mailbox_email || null">
								{{item.mailbox_email || 'None'}}
							</span>
							<ng-container *ngTemplateOutlet="mailboxJobTitleTemplate; context: {$implicit: item}"></ng-container>
						</div>
					</ng-container>
				</span>
				<!--recipient job role (executive recipients) shown as a secondary line under the mailbox-->
				<ng-template #mailboxJobTitleTemplate let-item>
					<div class="flex-row gap-1 mt-1 align-items-center text-muted" style="font-size: 11.5px;"
						 *ngIf="item.malicious?.tpResults?.resHead?.isExecutiveRecipient">
						<i class="far fa-user-tie text-success" tooltip="Executive Role"></i>
						<span class="ellipsis">{{item.malicious?.tpResults?.resHead?.recipientJobTitle || 'Executive'}}</span>
					</div>
				</ng-template>
				<span *ngIf="cellId === 'statusCell'">
					<div class="flex-row gap-1"
						 [ngStyle]="{'color': item.status === dic.CONSTANTS.quarantinedActions.quarantine.value && 'var(--ui-warning)' ||
						  					  item.status === dic.CONSTANTS.quarantinedActions.release.value && 'var(--ui-success)' ||
						  					  item.status === dic.CONSTANTS.quarantinedActions.remove.value && 'var(--ui-danger)' ||
						  					  item.status === dic.CONSTANTS.quarantinedActions.pending.value && 'var(--ui-text-muted)' ||
						  					  item.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value && 'var(--ui-danger)'}">
						<span class="text-capitalize">
							{{item?.status === dic.CONSTANTS.quarantinedActions.release.value ? 'Released' :
							  item.status === dic.CONSTANTS.quarantinedActions.remove.value ? 'Removed' :
								item.status === dic.CONSTANTS.quarantinedActions.pending.value ? 'Pending Release' :
								item.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value ? 'Release Failure' :
								item.status}}
						</span>
					</div>
					<!--CC: reason moved under the status as a muted second line instead of inline parentheses-->
					<div class="text-muted ellipsis" style="font-size: 11.5px; line-height: 1.3;" *ngIf="item.reason" [tooltip]="item.reason">
						{{item.reason}}
					</div>
				</span>
				<span *ngIf="cellId === 'categoryCell'">
					<div class="flex-row gap-1 align-items-center">
						<!--CC: category shown as a chip (same look as the threat tags) instead of colored plain text-->
						<div class="flex-row align-items-center threat-tag not-clickable m-0" [ngClass]="item.color">
							<div class="threat-tag-BG"></div>
							<span class="threat-tag-text">{{item.category}}</span>
						</div>
						<i *ngIf="item.diffCategory && !item.parent_id" class="far fa-exclamation-circle"
						   tooltip="Category is different for some recipients"></i>
					</div>
				</span>
				<div *ngIf="cellId === 'tagsCell'">
					<div class="flex-row align-items-center flex-wrap overflownV" *ngIf="item.threatTags?.length">
						<div class="flex-row align-items-center threat-tag hvr-opacity gap-1"
							 *ngFor="let tag of item.threatTags"
							 [ngClass]="tag.colorObj.color"
							 [ngStyle]="{'color': tag.colorObj.color}"
							 (click)="$event.stopPropagation(); this.activeTagAsFilter = tag.name; quarantinedTable.searchItem();">
							<div class="threat-tag-BG"></div>
							<i class="far threat-tag-icon" [ngClass]="tag.colorObj.icon"></i>
							<span class="threat-tag-text" [style.font-size.px]="tag.name?.length > 18 ? 10.5 : 12">{{tag.name}}</span>
						</div>
					</div>
				</div>
			</ng-template>

			<div tableButtons>
				<ng-container [ngTemplateOutlet]="queryEl"></ng-container>
			</div>
		</trustifi-table-c>
		<!--<span style="color: black; font-size: 0.9rem; background: linear-gradient(0deg, #ffffff00, white), linear-gradient(90deg,white, #f7f7f778, white); width: fit-content; margin: auto; padding: 18px; border: solid 1px white; font-weight: 300; border-radius: 5px;" *ngIf="!getEmailsInProcess && !batchesCounter">
			Create a query in the section above, then click on <b>"Get Emails"</b> to show the results
		</span>-->
    </div>

	<!--contentTooltip template (for sender)-->
	<ng-template #cToolTipTemplate let-groupEmail>
		<div contentTooltip>
			<ng-template #contentToolTipTemplate>
				<div class="vSpace3">
					<div class="hSpace1" style="font-size: 11px; display: flex;">
						<b style="flex-shrink: 0; ">From</b>:&nbsp;
						<span class="ellipsis"
								  tooltip="{{groupEmail.sender}}">{{groupEmail.sender}}</span>&nbsp;
							<a (click)="copyItemToClipboard(groupEmail.sender);  $event.stopPropagation();">
							<i class="far fa-copy copy-link" tooltip="Copy Email"></i>
						</a>
					</div>
						<div *ngIf="groupEmail?.malicious?.tpResults && groupEmail?.malicious?.tpResults?.resHead?.from?.returnPath"
						 class="hSpace1"
						 style="font-size: 11px; display: flex;">
						<b style="flex-shrink: 0; ">Return-Path</b>:&nbsp;
						<span class="ellipsis"
								  tooltip="{{groupEmail.malicious.tpResults.resHead.from.returnPath}}">{{groupEmail.malicious.tpResults.resHead.from.returnPath}}</span>&nbsp;
							<a (click)="copyItemToClipboard(groupEmail.malicious.tpResults.resHead.from.returnPath); $event.stopPropagation();">
							<i class="far fa-copy copy-link" tooltip="Copy Return-Path"></i>
						</a>
					</div>
					<div class="hSpace1" style="font-size: 11px; display: flex;">
						<b style="flex-shrink: 0; ">Message-ID</b>:&nbsp;
						<span style="direction: rtl;" class="ellipsis"
								  tooltip="{{groupEmail.message_id}}"
								  placement="bottom">{{groupEmail.message_id}}</span>&nbsp;
							<a (click)="copyItemToClipboard(groupEmail.message_id); $event.stopPropagation();">
							<i class="far fa-copy copy-link" tooltip="Copy Message-ID"></i>
						</a>
					</div>
				</div>
			</ng-template>
		</div>
	</ng-template>

    <!--Set Email Category popup-->
	<!--Change notification options popup-->
	<popup-c class="overflownV" *ngIf="notifyOptionsPopup?.show"
			 head="Notification Options For Your Mailbox"
			 (closeCb)="notifyOptionsPopup = null"
			 (confirmCb)="changeNotifyPeriod()"
			 [buttons]="{confirm: {text: 'Confirm', loading: notifyOptionsPopup.changeNotifyPeriodInProcess}}"
			 size="dynamic">
		<div class="flxClmn vSpace2 f-1-0" style="overflow: visible; min-height: 130px;">
			<span>Select the notification timing on quarantined emails.</span>

			<div class="flxRow hSpace1" style="align-items: flex-start;">
				<span style="flex-basis: 170px; flex-shrink: 0; color: var(--ui-text-muted);">Currently:</span>
				<div class="flxClmn vSpace05" style="color: var(--ui-text-muted);">
					<span>{{notifyOptionsPopup.currentDisplay.periods}}</span>
					<span *ngIf="notifyOptionsPopup.currentDisplay.hasCustomTimes">Hours: {{notifyOptionsPopup.currentDisplay.hours}}</span>
					<span *ngIf="notifyOptionsPopup.currentDisplay.hasCustomTimes">Days: {{notifyOptionsPopup.currentDisplay.days}}</span>
				</div>
			</div>

			<div class="flxRow hSpace1" style="align-items: center; z-index: 50;">
				<span style="flex-basis: 160px; flex-shrink: 0;">Select notification timing:</span>
				<div style="flex: 1 0; position: relative;">
					<app-dropdown-c style="width: 300px; min-width: 100%;"
									[error]="notifyOptionsPopup.isNotifyReviewerPeriodsError"
									text="{{notifyOptionsPopup.periods && _.keys(_.pickBy(notifyOptionsPopup.periods)).join(', ').replace('Notify every day', 'Custom notification times') || 'Select'}}">
						<li *ngFor="let periodKey of dic.CONSTANTS.tpRule.notifyOptions | keyvalue: gs.returnZero"
							(click)="notifyOptionsPopup.periods[periodKey.value] = !notifyOptionsPopup.periods[periodKey.value]; notifyOptionsPopup.isNotifyReviewerPeriodsError = false; $event.stopPropagation();"
							id="{{'notifyReviewerPeriod_' + periodKey.key}}">
							<checkbox (click)="$event.preventDefault();"
									  [model]="notifyOptionsPopup.periods[periodKey.value]">
								{{periodKey.value === dic.CONSTANTS.tpRule.notifyOptions.everyDay ? 'Custom notification times' : periodKey.value}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -20px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyReviewerPeriodsError">
                            required field
                        </span>
				</div>
			</div>
			<div class="flxRow hSpace1 animated fadeIn w100" style="align-items: center; margin-top: 10px; z-index: 40;" *ngIf="notifyOptionsPopup.periods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<span style="flex-basis: 160px;">Select notification hours:</span>
				<div style="position: relative; flex: 1 0;">
					<app-dropdown-c class="limit-height" style="width: 300px; min-width: 100%;"
									[error]="notifyOptionsPopup.isNotifyReviewerDailyHoursError"
									text="{{gs.getDailyHoursText(notifyOptionsPopup.dailyHours) || 'Select'}}">
						<li *ngFor="let twoDigitHour of gs.hoursArr"
							(click)="toggleNotificationDailyHour(notifyOptionsPopup.dailyHours, twoDigitHour); $event.stopPropagation();"
							id="{{'notifyReviewerDailyHour_' + twoDigitHour}}">
							<checkbox (click)="$event.preventDefault();"
									  [model]="notifyOptionsPopup.dailyHours.includes(twoDigitHour)">
								{{twoDigitHour + ':00'}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
					  *ngIf="notifyOptionsPopup.isNotifyReviewerDailyHoursError">
						required field
					</span>
				</div>
			</div>
			<div class="flxRow hSpace1 animated fadeIn" style="align-items: center; margin-top: 10px; z-index: 39;" *ngIf="notifyOptionsPopup.periods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<span style="flex-basis: 160px;">Select notification days:</span>
				<div style="position: relative; flex: 1 0;">
					<app-dropdown-c class="limit-height" style="width: 300px; min-width: 100%;"
									[error]="notifyOptionsPopup.isNotifyReviewerDaysError"
									[items]="notifyOptionsPopup.notifyReviewerDays"
									[isMultipleSelection]="true"
									[hideCounter]="true"
									itemDisplayKey="day">
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyReviewerDaysError">
                            required field
					</span>
				</div>
			</div>
		</div>
	</popup-c>

	<quarantined-email-action
		*ngIf="quarantinedEmailAction"
		[action]="quarantinedEmailAction.action"
		[email]="quarantinedEmailAction.email"
		[data]="quarantinedEmailAction.data"
		[planInfo]="quarantinedPlanInfo"
		(onActionDone)="onQuarantinedActionDone($event)"
		(viewEmailsFromSenderCb)="viewEmailFromSender($event)"
		(keyNavigateCb)="navigateThreatAnalysisEmail($event)"
		(doneCb)="quarantinedEmailAction = null; selectionReviewQueue = [];">
	</quarantined-email-action>
	<!--threat analysis navigation progress (arrows / bulk slideshow)-->
	<div class="nav-progress" *ngIf="quarantinedEmailAction?.action === dic.CONSTANTS.quarantinedActions.viewInfo.display && threatNavigationEmails.length > 1 && currentThreatNavigationIndex >= 0">
		<div class="nav-progress-pill">
			<span class="nav-progress-count">{{currentThreatNavigationIndex + 1}}</span>
			<span class="nav-progress-sep">{{dic.CONSTANTS.threatNavigationProgress.of}}</span>
			<span class="nav-progress-total">{{threatNavigationEmails.length}}</span>
		</div>
	</div>
	<button class="nav-arrow animated fadeIn" style="left: 7px;"
			aria-label="Previous email"
			*ngIf="canNavigateThreatPrev()"
			(click)="navigateThreatAnalysisEmail(-1, $event)">
		<i class="far fa-chevron-left"></i>
	</button>
	<button class="nav-arrow animated fadeIn" style="right: 7px;"
			aria-label="Next email"
			*ngIf="canNavigateThreatNext()"
			(click)="navigateThreatAnalysisEmail(1, $event)">
		<i class="far fa-chevron-right"></i>
	</button>
</div>
